import { getNatureNamesByValues } from '../../../caracteristiques/services/natures.enum';

export default class MesureDetailController {
    static $inject = ['$stateParams', '$state', 'MesuresService', 'notification', 'MesuresCommunicationService', 'MassiaApplicationService'];

    constructor($stateParams, $state, MesuresService, notification, MesuresCommunicationService, MassiaApplicationService) {
        this.$stateParams = $stateParams;
        this.$state = $state;
        this.MesuresService = MesuresService;
        this.notification = notification;
        this.MesuresCommunicationService = MesuresCommunicationService;
        this.MassiaApplicationService = MassiaApplicationService;
    }

    $onInit() {
        this.loading = false;
        this.mesure = {};
        this.caracteristiques = [];

        this.ongletOpen = {
            isEnteteOpen: true,
            isCaracteristiqueOpen: false,
            isSousMesuresOpen: false
        };

        this.initMesure();
    }

    getDomaineCourant() {
        if (this.$state.current.name === 'mesures.list' || this.$state.current.name === 'mesures.list.detail') {
            return 'mesures';
        } else if (this.$state.current.name === 'mesctrl.list' || this.$state.current.name === 'mesctrl.list.detail') {
            return 'mesctrl';
        } else if (this.$state.current.name === 'messecu.list' || this.$state.current.name === 'messecu.list.detail') {
            return 'messecu';
        } else if (this.$state.current.name === 'essais.list' || this.$state.current.name === 'essais.list.detail') {
            return 'essais';
        }
    }

    async initMesure() {
        this.mesure = { id: this.$stateParams.id };
        if (this.mesure.id) {
            this.startLoading();
            try {
                this.mesure.entete = await this.MesuresService.getMesureEnteteById(this.mesure.id);
                this.mesure.sousMesures = await this.MesuresService.getMesureSousMesuresById(this.mesure.id);
                this.mesure.caracteristiques = await this.MesuresService.getMesureValeursCaracteristiquesById(this.mesure.id);
                this.setCaracteristiques(this.mesure.caracteristiques);
            } catch (ex) {
                if (ex.status === 404) {
                    this.goListMesure();
                }
                this.notification.error(ex.data);
            } finally {
                this.stopLoading();
            }
        } else {
            this.goListMesure();
        }
    }

    async getMesureEntete(mesureId) {
        this.mesure.entete = await this.MesuresService.getMesureEnteteById(mesureId);
    }

    async setCaracteristiques(caracteristiques = []) {
        const natures = getNatureNamesByValues();
        this.caracteristiques = [];
        caracteristiques.forEach((c) => {
            this.caracteristiques.push({
                code: c.code,
                label: c.label,
                values: getValue(c.value),
                nature: natures[c.idNature],
                numericAdditionalInformation: c.numericAdditionalInformation,
                labelCls: 'col-xs-12 col-sm-4',
                inputCls: 'col-xs-12 col-sm-8'
            });
        });

        function getValue(val) {
            if (angular.isArray(val)) {
                if (_.some(val, 'key')) {
                    return _.map(val, 'value');
                }
                return val;
            }
            return [val];
        }
    }

    goListMesure() {
        this.$state.go(this.getDomaineCourant() + '.list', {}, { reload: true });
    }

    startLoading() {
        this.loading = true;
    }

    stopLoading() {
        this.loading = false;
    }
}
